// components/ImageWithSkeleton.tsx
import React, { useState } from 'react';
import './ImageWithSkeleton.css';

interface ImageWithSkeletonProps {
  src: string;
  alt: string;
  fallback?: string;
  className?: string;
  to?: string;
}

const ImageWithSkeleton: React.FC<ImageWithSkeletonProps> = ({
  src,
  alt,
  fallback = '/images/fallback.jpg',
  className = '',
  to = '/product',
}) => {
  const [loading, setLoading] = useState(true);

  const handleImageLoad = () => setLoading(false);

  return (
    <div className={`image-wrapper ${className}`}>
      {loading && <div className="skeleton-loader" />}
      <img
        src={src || fallback}
        alt={alt}
        className={`loaded-image ${loading ? 'hidden' : 'visible'}`}
        onLoad={handleImageLoad}
      />
    </div>
  );
};

export default ImageWithSkeleton;
